import { render, staticRenderFns } from "./gutter-editor.vue?vue&type=template&id=ebfa1f06&scoped=true&"
import script from "./gutter-editor.vue?vue&type=script&lang=js&"
export * from "./gutter-editor.vue?vue&type=script&lang=js&"
import style0 from "./gutter-editor.vue?vue&type=style&index=0&id=ebfa1f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa1f06",
  null
  
)

export default component.exports